import './index.scss';

import React from 'react';
import { useTrans } from 'core/hooks';
import OverlayComponent from './OverlayComponent';

type IProps = {
  // productId: number
  filterResult: string[]; // result from createSelectApplyFilterToProduct
};

export default function FilterOverlayText({ filterResult }: IProps) {
  const trans = useTrans();
  //
  // const selectApplyFilterToProduct = useMemo(
  //   createSelectApplyFilterToProduct,
  //   []
  // )
  // const results = useSelector((state: AppState) =>
  //   selectApplyFilterToProduct(state, props.productId)
  // )
  //
  // if (results.length === 0 || results.indexOf('status') > -1) {
  //   return null
  // }

  return (
    <OverlayComponent>
      <div className="foverlay">
        <div className="foverlay__circle">
          <div className="foverlay__title">
            {trans('filter_matcher.doesnt')} <br />{' '}
            {trans('filter_matcher.search_on')}
          </div>
          <ul className="foverlay__list">
            {filterResult.map((result, rIndex) => (
              <li key={rIndex}>{trans(result)}</li>
            ))}
          </ul>
        </div>
      </div>
    </OverlayComponent>
  );
}
